var map = {
	"./logo.png": 955
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 954;


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/transplant/documents ^\.\/.*$
// module id = 954
// module chunks = 1